import {r as c} from '@theme/theme-sections';
import {F as d} from '@theme/flickity';
import '@theme/flickity-fade';
import '@theme/_commonjsHelpers';
const l = {sliderContainer: '[data-slider]'},
  i = 'trust-icons';
var o, s, r;
const p =
    ((r = (s = (o = window.Shopify) == null ? void 0 : o.theme) == null ? void 0 : s.sections) == null
      ? void 0
      : r.registered) || {},
  u = typeof p[i] > 'u';
u &&
  c(i, {
    onLoad() {
      const e = this.container,
        t = e.querySelector(l.sliderContainer);
      if (!t) return;
      const a = e.dataset.autoplay === 'true',
        n = Number(e.dataset.autoplaySpeed);
      this.flickity = new d(t, {
        prevNextButtons: !1,
        autoPlay: a ? n : !1,
        pageDots: !0,
        adaptiveHeight: !1,
        fade: !0,
        watchCSS: !0,
      });
    },
  });
